import {ethiotelConfig} from "@/config";
import {getBrandConfig} from "@/brand";

const ERROR_MESSAGES = {
    '-72': 'MSISDN already active',
    '-78': 'Invalid MSISDN',
    '-79': 'Blacklisted MSISDN',
    '-1': 'Error on subscription',
    '14': 'Successfully subscribed to the service',
    '-68': 'You have exceeded the limit for wrong PIN',
    '-274': 'Fraud check has failed',
    '-81': 'OTP validation time has expired'
};

export function parseSubscriptionResponse(code, message) {
    const successCodes = [14];
    const errorCodes = [-1, -68, -72, -78, -79, -274];

    if (successCodes.includes(code) || message.toLowerCase().includes('active')) {
        return {
            status: 'success',
            code: code,
            message: message
        };
    } else if (errorCodes.includes(code) || code < 0) {
        return {
            status: 'error',
            code: code,
            message: message
        };
    } else {
        return {
            status: 'unknown',
            code: code,
            message: message
        };
    }
}

export function getErrorMessage(code) {
    const codeStr = String(code);
    return ERROR_MESSAGES[codeStr] || `Subscription failed with code: ${code}`;
}

export function generateBasicAuth() {
    const credentials = `${ethiotelConfig.username}:${ethiotelConfig.password}`;
    const base64Credentials = btoa(credentials);
    return `Basic ${base64Credentials}`;
}


export function getCrossSellConfig(currentBrand) {
    // Define cross-sell mappings
    const crossSellMap = {
        'blg-en': 'fantasy-soccer-en',
        'fantasy-soccer-en': 'blg-en'
    };

    const crossSellBrand = crossSellMap[currentBrand];

    if (!crossSellBrand) {
        return null;
    }

    return getBrandConfig(crossSellBrand);
}


